import { useState } from "react";
import { Button, type ButtonVariant } from "../Button/Button";
import { writeClipboard } from "./clipboard";

/** How long the button says "Copied" before going back to its label. */
const COPIED_FEEDBACK_MS = 1800;

export interface CopyButtonProps {
  value: string;
  label?: string;
  copiedLabel?: string;
  variant?: ButtonVariant;
  size?: "sm" | "md";
  iconOnly?: boolean;
}

export function CopyButton({
  value,
  label = "Copy",
  copiedLabel = "Copied",
  variant = "secondary",
  size = "md",
  iconOnly,
}: CopyButtonProps): React.JSX.Element {
  const [copied, setCopied] = useState(false);

  function copy(): void {
    void writeClipboard(value).then((ok) => {
      if (!ok) return;
      setCopied(true);
      window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    });
  }

  return (
    <Button
      label={copied ? copiedLabel : label}
      icon={copied ? "check" : "copy"}
      variant={variant}
      size={size}
      iconOnly={iconOnly}
      aria-live="polite"
      onClick={copy}
    />
  );
}
